export default ['index', 'action'];
